export default __webpack_public_path__ + "static/ont-logo-6794693d5c4835721d3d50fd2467c19e.svg";